
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ToolbarService } from 'src/app/common/components/toolbar/toolbar.service';
import { Subscription } from 'rxjs';
import { AppConstants } from 'src/app/common/app.constants';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  standalone: false
})

export class UserMenuComponent implements OnDestroy {

  @Input() show: boolean = false;


  toolbarToggleEventSub: Subscription;
  userData: any = null;


  constructor(private toolbarService: ToolbarService, private stateManagerService: StateManagerService, private permissionService: PermissionService) {

    /**
     * Subscribes the toolbar events
     */
    this.toolbarToggleEventSub = this.toolbarService.menuToggleEvent.subscribe(() => {
      this.toggleOptionBar();
    });
    this.show = this.toolbarService.isVisible;

    const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
    }

  }

  /**
   * Check if user has access to the page
   * @param page
   * @returns
   */
  hasAccess(page: string): boolean {
    return this.permissionService.hasPermission(page, 'view');
  }

  /**
   * un register the subscription
   */
  ngOnDestroy(): void {
    this.toolbarToggleEventSub.unsubscribe();
  }

  /**
   * Toggles the display of optioin bar
   */
  toggleOptionBar(): void {
    this.show = !this.show;
  }
  resetState() {
    // Call the resetState function
    this.stateManagerService.resetState();
  }

}

